<template>
    <div id="desktop">
        this is desktop
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
    },
    data: () => {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
#desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    @include tablet {}

}
</style>